import React from 'react'
import { StyledSubjectVideosGrid } from './subject-videos.style'
import SubjectVideosItem from './subject-videos-item'

const SubjectVideos = () => {
    return (
        <>
            <StyledSubjectVideosGrid>
                <SubjectVideosItem subject="Definition of Numbers" imgUrl="/assets/images/subject/subject-video-image.png" />
                <SubjectVideosItem subject="Place Value" imgUrl="/assets/images/subject/subject-video-image.png" />
                <SubjectVideosItem subject="Basic Operations" imgUrl="/assets/images/subject/subject-video-image.png" />
                <SubjectVideosItem subject="Counting in Base Two" imgUrl="/assets/images/subject/subject-video-image.png" />
            </StyledSubjectVideosGrid>
        </>
    )
}

export { SubjectVideos }
